const route = {
	path: ':subsidiaryId?/ledger',
	name: 'ledger',
	meta: {
		title: 'Libro Mayor',
	},
	component: () => import('@/pages/journal/page-ledger'),
	props: true,
};

export default route;



// WEBPACK FOOTER //
// ./src/router/ledger.js